<template>
  <v-col cols="12" sm="6" md="6" class="filter mt-0 pt-0">
    <v-autocomplete
      class="pa-0 ma-0"
      :items="getFilters"
      v-model="getDefaultFilter"
      item-text="name"
      item-value="id"
      @change="(event) => getFilterInformation(event)"
      :append-icon="'mdi-eye-remove'"
      :no-data-text="$tc('filter.notEmployees')"
      @click:append="readOnlyFilter"
    >
    </v-autocomplete>
    <v-dialog v-model="dialogDelete" width="390px">
      <v-card style="height: 150px">
        <v-card-title
          style="display: flex; justify-content: center"
          class="title-delete"
          v-if="!isDefault"
          >{{ $tc("filter.deleteFilter") }}</v-card-title
        >
        <v-card-title
          v-else
          style="display: flex; justify-content: center"
          class="title-delete"
        >
          {{ $tc("filter.deleteDefault") }}
        </v-card-title>
        <v-card-actions class="actions-delete">
          <v-btn class="grey white--text" @click="dialogDelete = false">{{
            $tc("filter.cancel")
          }}</v-btn>
          <v-btn
            @click="deleteFilter()"
            class="btn-delete"
            :disabled="getDefaultFilter == undefined"
          >
            {{ $tc("filter.delete") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu
      :close-on-content-click="false"
      style="max-width: 150px"
      v-model="cardFilter"
    >
      <template v-slot:activator="{ on, attrs }">
        <span :title="$tc('filter.createFilter')">
          <v-icon
            class="my-2 pl-3"
            style="cursor: pointer"
            v-bind="attrs"
            v-on="on"
            @click="defaultItem"
            >fa-plus
          </v-icon>
        </span>
      </template>

      <v-card class="card-filter">
        <v-form ref="form" v-model="formFilter" lazy-validation>
          <v-card-text
            style="display: flex; flex-direction: row; max-height: 80px"
          >
            <v-select
              :items="itemsE"
              label="Empleados"
              outlined
              v-model="selectEmployees"
              append-icon="fa-users"
              style="max-width: 330px"
              class="itemsE"
              @input="changeEmp"
            >
            </v-select>

            <v-autocomplete
              class="options"
              v-if="selectEmployees == 'Un empleado o varios'"
              outlined
              v-model="data.Empleados"
              :items="getNames"
              multiple
              item-value="empId"
              :item-text="formatItemText"
              :no-data-text="$tc('filter.notEmployees')"
              :label="$tc('filter.select')"
              @input="changeModel"
              @change="handleModelChange"
              ref="autocomplete"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index <= 0">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+ {{ data.Empleados.length - 1 }} )
                </span>
              </template>
            </v-autocomplete>
            <v-autocomplete
              class="options"
              v-else-if="selectEmployees == 'Un grupo de empleados o varios'"
              outlined
              v-model="data.Grupos"
              item-value="groupId"
              item-text="name"
              :items="getGroups"
              :label="$tc('filter.select')"
              multiple
              @input="changeModel"
              @change="handleModelChange"
              ref="autocomplete"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index <= 1">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text text-caption">
                  (+ {{ data.Grupos.length - 2 }} )
                </span>
              </template>
            </v-autocomplete>
            <v-autocomplete
              class="options"
              v-else-if="selectEmployees == 'Empleados por atributo'"
              :items="getAttributes"
              outlined
              item-value="atribId"
              item-text="name"
              v-model="data.Atributos"
              :label="$tc('filter.select')"
              multiple
              @input="changeModel"
              @change="handleModelChange"
              ref="autocomplete"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index <= 1">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 2" class="grey--text text-caption">
                  (+ {{ data.Atributos.length - 2 }} )
                </span>
              </template>
            </v-autocomplete>
            <v-autocomplete
              class="options"
              v-else-if="selectEmployees == 'Empleados por horario'"
              :items="getSchedules"
              outlined
              item-value="scheduleId"
              item-text="name"
              v-model="data.Horarios"
              :label="$tc('filter.select')"
              multiple
              @input="changeModel"
              @change="handleModelChange"
              ref="autocomplete"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index <= 2">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 3" class="grey--text text-caption">
                  (+ {{ data.Horarios.length - 3 }} )
                </span>
              </template>
            </v-autocomplete>
            <v-autocomplete
              class="options"
              v-else-if="selectEmployees == 'Empleados por modelo'"
              :items="getModels"
              item-value="liqmodelId"
              item-text="name"
              v-model="data.Modelos"
              outlined
              :label="$tc('filter.select')"
              multiple
              @input="changeModel"
              @change="handleModelChange"
              ref="autocomplete"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index <= 2">
                  <span>{{ item.name }}</span>
                </v-chip>
                <span v-if="index === 3" class="grey--text text-caption">
                  (+ {{ data.Modelos.length - 3 }} )
                </span>
              </template>
            </v-autocomplete>
          </v-card-text>
        </v-form>
        <v-list class="content-items" v-show="viewRegis">
          <status
            :options="normalOptions"
            :selectedOptions="normals"
            :selectLabel="normalsLabel"
            @onChange="handleChangeNormals"
          />

          <status
            :options="advertismentOptions"
            :selectedOptions="advertisments"
            :selectLabel="advertismentLabel"
            @onChange="handleChangeAdvertisments"
          />
          <status
            :options="extrasOptions"
            :selectedOptions="extras"
            :selectLabel="extrasLabel"
            @onChange="handleChangeExtras"
          />
          <status
            :options="anomaliesOptions"
            :selectedOptions="anomalies"
            :selectLabel="anomaliesLabel"
            @onChange="handleChangeAnomalies"
          />
        </v-list>

        <v-divider></v-divider>
        <v-row class="my-auto">
          <v-checkbox
            :label="$tc('filter.defaultFilter')"
            v-model="defaultFilter"
            class="ml-5"
          ></v-checkbox>
          <v-col class="buttons my-auto">
            <v-dialog width="400px" v-model="dialog">
              <template v-slot:activator="{ on, attrs }">
                <v-btn small v-bind="attrs" v-on="on" class="bt-acept ml-5 mr-2"
                  >{{ $tc("filter.saveApply") }}
                </v-btn>
              </template>

              <v-card>
                <v-card-title style="display: flex; justify-content: center">
                  {{ $tc("filter.saveFilter") }}</v-card-title
                >
                <v-card-subtitle>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-text-field
                      :label="$tc('filter.nameFilter')"
                      v-model="nameFilter"
                      :rules="rules"
                      :counter="32"
                    >
                    </v-text-field>
                  </v-form>
                </v-card-subtitle>
                <v-card-actions
                  style="display: flex; justify-content: space-around"
                  class="buttons"
                >
                  <v-btn class="bt-exit" @click="cancelFilter">{{
                    $tc("filter.cancel")
                  }}</v-btn>
                  <v-btn class="bt-acept" @click="validate">{{
                    $tc("filter.save")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-btn small class="bt-exit mr-3 ml-1" @click="cancelFormFilter"
              >{{ $tc("filter.cancel") }}
            </v-btn>
            <v-btn small color="primary" class="mr-2" @click="applyFilter()"
              >{{ $tc("filter.apply") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-menu>
    <v-dialog v-model="showfilterReadOnly" max-width="650px">
      <v-card v-if="filterReadOnly">
        <div class="container__iconClose">
          <v-icon
            class="mr-3 mt-5"
            small
            style="cursor: pointer"
            @click="showfilterReadOnly = false"
            >✖️</v-icon
          >
        </div>
        <v-card-title class="card__title__readOnly"
          >{{ filterReadOnly.name }}
        </v-card-title>
        <v-card-actions class="card__action__readOnly">
          <div>
            <h4 style="width: 600px">{{ parseFilterReadOnly.type }}</h4>
            <div class="container__namesfilter">
              <div
                v-for="(item, index) in parseFilterReadOnly.items"
                :key="index"
              >
                <p class="ml-2 grid__item">{{ item.Nombre }}</p>
              </div>
            </div>
          </div>
          <div class="card__checks">
            <v-checkbox
              disabled
              v-model="parseFilterReadOnly.estado.Anomalias"
              label="Anomalias"
            />
            <v-checkbox
              disabled
              v-model="parseFilterReadOnly.estado.Extras"
              label="Extras"
            />
            <v-checkbox
              disabled
              v-model="parseFilterReadOnly.estado.Normales.Detalle.DiasLIH"
              label="Lic. Horas"
            />
            <v-checkbox
              disabled
              v-model="parseFilterReadOnly.estado.Normales.Detalle.DiasLiD"
              label="Lic. Días"
            />
          </div>
          <div class="card__checks">
            <v-checkbox
              disabled
              v-model="parseFilterReadOnly.estado.Normales.Detalle.SinNovedad"
              label="Sin novedades"
            />
            <v-checkbox
              disabled
              v-model="parseFilterReadOnly.estado.Avisos.Detalle.DiasHca"
              label="Caidas"
            />
            <v-checkbox
              disabled
              v-model="parseFilterReadOnly.estado.Avisos.Detalle.DiasInc"
              label="Inconsistencia"
            />
            <v-checkbox
              disabled
              v-model="parseFilterReadOnly.estado.Avisos.Detalle.DiasRet"
              label="Retiro"
            />
            <v-checkbox
              disabled
              v-model="parseFilterReadOnly.estado.Avisos.Detalle.DiasTar"
              label="Tarde"
            />
          </div>
        </v-card-actions>

        <div
          style="
            display: flex;
            flex-direction: row;
            justify-content: center;
            padding: 15px;
          "
        >
          <v-btn
            small
            @click="showfilterReadOnly = false"
            class="mr-2"
            color="grey"
            style="color: white"
            >cancelar</v-btn
          >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                color="primary"
                class="mr-2"
                v-bind="attrs"
                @click="changeFilterDefault"
                v-on="on"
                :disabled="isDefault"
              >
                Default
              </v-btn>
            </template>
            <span>Establecer como default</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                color="#e86868"
                style="color: white"
                v-bind="attrs"
                @click="openDeleteModal"
                v-on="on"
              >
                eliminar
              </v-btn>
            </template>
            <span>Eliminar filtro</span>
          </v-tooltip>
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      color="#909DFA"
      class="snackbar"
      rounded="pill"
    >
      {{ $tc("filter.filter") }}
    </v-snackbar>
    <v-snackbar
      v-model="alertDefault"
      color="error"
      class="snackbar"
      rounded="pill"
    >
      {{ $tc("filter.defaultDelete") }}
    </v-snackbar>

    <loader v-if="loading" :loading="loading" />
  </v-col>
</template>

<script>
import loader from "../Complement/Loader.vue";
import moment from "moment";
import Status from "./Status.vue";
export default {
  components: { loader, Status },
  props: {
    dispatch: Function,
    viewRegis: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valueItems: null,
      valid: true,
      formFilter: true,
      rules: [
        (v) => v.length <= 32 || "Supero la cantidad de caracteres",
        (v) => !!v || this.$tc("editRegistrations.requerid"),
      ],
      itemsE: [
        "Un empleado o varios",
        "Un grupo de empleados o varios",
        "Empleados por atributo",
        "Empleados por horario",
        "Empleados por modelo",
      ],
      selectEmployees: [],
      data: {
        Empleados: [],
        Grupos: [],
        Horarios: [],
        Modelos: [],
        Atributos: [],
        Estado: {
          Normales: [],
          Avisos: [],
          Anomalias: [],
          Extras: [],
        },
      },
      nameFilter: "",
      defaultFilter: true,
      createAt: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      advertismentOptions: [
        "Inconsistencias",
        "Horas Caidas",
        "Retiros",
        "Tardes",
      ],
      flagApply: false,
      anomaliesOptions: ["Ausencias"],
      extrasOptions: ["Extras"],
      normalOptions: ["Licencia por hora", "Licencia por día", "Sin novedades"],
      normalsLabel: "Normales",
      advertismentLabel: "Avisos",
      extrasLabel: "Extras",
      anomaliesLabel: "Anomalías",
      normals: ["Licencia por hora", "Licencia por día", "Sin novedades"],
      advertisments: ["Inconsistencias", "Horas Caidas", "Retiros", "Tardes"],
      extras: ["Extras"],
      anomalies: ["Ausencias"],
      snackbar: false,
      dialog: false,
      dialogDelete: false,
      cardFilter: false,
      filtro: {
        id: null,
        name: "",
        operId: null,
        defaults: null,
        created: "",
        data: "",
      },
      loading: false,
      check: true,
      estados: [],
      date: this.$store.state.gestionTiempos.date,
      dateTo: this.$store.state.gestionTiempos.dateTo,
      alertDefault: false,
      isDefault: false,
      showfilterReadOnly: false,
      parseFilterReadOnly: {
        Empleados: [],
        Grupos: [],
        Horarios: [],
        Modelos: [],
        Atributos: [],
        estado: {
          Anomalias: null,
          Extras: null,
          Normales: {
            Detalle: {
              DiasLiD: null,
              DiasLIH: null,
              SinNovedad: null,
            },
          },
          Avisos: {
            Detalle: {
              DiasHca: null,
              DiasInc: null,
              DiasRet: null,
              DiasTar: null,
            },
          },
        },
      },
    };
  },
  //funciones que llaman a el state del store
  computed: {
    getFilterShow() {
      const filter = JSON.parse(this.$store.state.gestionTiempos.filterForShow);
      return filter;
    },
    getModels() {
      return this.$store.state.gestionTiempos.models;
    },
    getSchedules() {
      return this.$store.state.gestionTiempos.schedule;
    },
    getGroups() {
      return this.$store.state.gestionTiempos.groups;
    },
    getAttributes() {
      return this.$store.state.gestionTiempos.attributes;
    },
    getNames() {
      return this.$store.state.gestionTiempos.itemsEmployees;
    },
    getFilters() {
      return this.$store.state.gestionTiempos.filters;
    },
    getDefaultFilter: {
      get: function () {
        return this.$store.state.gestionTiempos.defaultFilter;
      },
      set: function (val) {
        let filter = this.getFilters.filter((item) => {
          return item.id == val;
        })[0];

        this.$store.commit("gestionTiempos/setNewDefaultFilter", { filter });

        return;
      },
    },
    filterReadOnly() {
      const filter = this.$store.state.gestionTiempos.defaultFilter;
      return !filter ? this.$store.state.gestionTiempos.filterReadOnly : filter;
    },
    getFilterId() {
      return this.$store.state.gestionTiempos.filterForShow;
    },
  },

  beforeUpdate() {
    this.$emit("onRefresh", this.$store.state.gestionTiempos.defaultFilter);
  },

  methods: {
    formatItemText(item) {
      return `${item.name} (${item.file})`;
    },
    handleModelChange() {
      this.$refs.autocomplete.internalSearch = "";
    },
    getFilterInformation(filter) {
      if (filter) {
        this.flagApply = false;
        this.$emit("flagApply", this.flagApply);

        this.$store.commit("gestionTiempos/setDeleteDisabled", false);
      }
      this.$store.commit("gestionTiempos/setFilterReadOnly", filter);
      this.$emit("onRefresh", this.$store.state.gestionTiempos.defaultFilter);
      this.cardFilter = false;
    },
    //se aplica el filtro , este filtro no se guarda
    applyFilter() {
      const data = {
        operId: parseInt(localStorage.getItem("operId"), 10),
        defecto: this.defaultFilter,
        nombre: this.nameFilter,
        creadoEl: moment(this.date).format(),
        data: this.data,
      };
      data.data.Estado.Normales = {
        Valor: this.normalOptions.length === this.normals.length,
        Detalle: {
          DiasLIH: this.normals.includes("Licencia por hora"),
          DiasLiD: this.normals.includes("Licencia por día"),
          SinNovedad: this.normals.includes("Sin novedades"),
        },
      };
      data.data.Estado.Avisos = {
        Valor: this.advertismentOptions.length === this.advertisments.length,
        Detalle: {
          DiasInc: this.advertisments.includes("Inconsistencias"),
          DiasHca: this.advertisments.includes("Horas Caidas"),
          DiasTar: this.advertisments.includes("Tardes"),
          DiasRet: this.advertisments.includes("Retiros"),
        },
      };

      data.data.Estado.Anomalias =
        this.anomaliesOptions.length === this.anomalies.length;
      data.data.Estado.Extras =
        this.extrasOptions.length === this.extras.length;
      this.flagApply = true;
      this.$emit("flagApply", this.flagApply);
      let payload = {
        operId: data.operId,
        defecto: data.defecto,
        nombre: data.nombre,
        creadoEl: data.creadoEl,
        data: JSON.stringify(data.data),
      };
      this.$store.commit("gestionTiempos/setDataFilterApply", data);

      this.$store.commit("gestionTiempos/setFilterApply", payload);
      this.$store.dispatch("gestionTiempos/newControllerApply", data);
      this.$store.dispatch("gestionTiempos/getRegis", payload);
      this.$store.commit("gestionTiempos/setNewDefaultFilter", { filter: {} });
      this.cardFilter = false;
      this.data = {
        Empleados: [],
        Grupos: [],
        Horarios: [],
        Modelos: [],
        Atributos: [],
        Estado: {
          Normales: [],
          Avisos: [],
          Anomalias: [],
          Extras: [],
        },
      };
      this.selectEmployees = [];
    },
    // se abre el modal de eliminar filtro
    openDeleteModal() {
      this.dialogDelete = true;
      if (this.$store.state.gestionTiempos.defaultFilter.defaults) {
        this.isDefault = true;
      } else {
        this.isDefault = false;
      }
    },
    //eliminar filtro
    deleteFilter() {
      let id = this.$store.state.gestionTiempos.defaultFilter.id;
      if (this.$store.state.gestionTiempos.defaultFilter.defaults) {
        this.alertDefault = true;
      }
      this.$store.commit("gestionTiempos/setDeleteFilter", id);
      this.$store.dispatch("gestionTiempos/deleteFilter").then(() => {
        this.showfilterReadOnly = false;
      });

      this.dialogDelete = false;
      this.$store.commit("gestionTiempos/setDeleteDisabled", true);
    },
    validate() {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.savefilter();
        this.$store.commit("gestionTiempos/setDeleteDisabled", false);
      }
    },
    //guardar filtro

    savefilter() {
      this.flagApply = false;
      const data = {
        operId: parseInt(localStorage.getItem("operId"), 10),
        defecto: this.defaultFilter,
        nombre: this.nameFilter,
        creadoEl: moment(this.date).format(),
        data: this.data,
      };

      data.data.Estado.Normales = {
        Valor: this.normalOptions.length === this.normals.length,
        Detalle: {
          DiasLIH: this.normals.includes("Licencia por hora"),
          DiasLiD: this.normals.includes("Licencia por día"),
          SinNovedad: this.normals.includes("Sin novedades"),
        },
      };
      data.data.Estado.Avisos = {
        Valor: this.advertismentOptions.length === this.advertisments.length,
        Detalle: {
          DiasInc: this.advertisments.includes("Inconsistencias"),
          DiasHca: this.advertisments.includes("Horas Caidas"),
          DiasTar: this.advertisments.includes("Tardes"),
          DiasRet: this.advertisments.includes("Retiros"),
        },
      };

      data.data.Estado.Anomalias =
        this.anomaliesOptions.length === this.anomalies.length;
      data.data.Estado.Extras =
        this.extrasOptions.length === this.extras.length;

      this.$store.commit("gestionTiempos/setNewFilter", data);
      this.$store.dispatch("gestionTiempos/newFilter").then(() => {
        this.$store.dispatch("gestionTiempos/getFilters");
      });
      this.$store.dispatch("gestionTiempos/newControllerApply", data);

      let payload = {
        operId: data.operId,
        defecto: data.defecto,
        nombre: data.nombre,
        creadoEl: data.creadoEl,
        data: JSON.stringify(data.data),
      };
      this.$store.dispatch("gestionTiempos/getRegis", payload);
      this.dialog = false;
      this.snackbar = true;
      this.cardFilter = false;

      this.selectEmployees = "";
      this.nameFilter = "";
      this.normals = ["Licencia por hora", "Licencia por día", "Sin novedades"];
      this.advertisments = [
        "Inconsistencias",
        "Horas Caidas",
        "Retiros",
        "Tardes",
      ];
      this.extras = ["Extras"];
      this.anomalies = ["Ausencias"];
      this.selectEmployees = [];
    },
    handleChangeNormals(options) {
      this.normals = options;
    },
    handleChangeAdvertisments(options) {
      this.advertisments = options;
    },
    handleChangeExtras(options) {
      this.extras = options;
    },
    handleChangeAnomalies(options) {
      this.anomalies = options;
    },
    cancelFilter() {
      this.dialog = false;
      this.defaultItem();
    },
    // los items quedan en default
    defaultItem() {
      this.dispatch();
      this.normalOptions = [
        "Licencia por hora",
        "Licencia por día",
        "Sin novedades",
      ];

      this.normals = ["Licencia por hora", "Licencia por día", "Sin novedades"];

      this.advertismentOptions = [
        "Inconsistencias",
        "Horas Caidas",
        "Retiros",
        "Tardes",
      ];
      this.anomaliesOptions = ["Ausencias"];
      this.extrasOptions = ["Extras"];
      this.selectEmployees = [];
    },
    //se cancela el formulario de filtro
    cancelFormFilter() {
      this.cardFilter = false;
      this.$refs.form.reset();
    },
    readOnlyFilter() {
      this.$store.commit("gestionTiempos/setDeleteDisabled", false);

      const idFilter = this.filterReadOnly.id;
      this.$store.commit("gestionTiempos/setIdFilterShow", idFilter);

      this.$store.dispatch("gestionTiempos/showFilter").then(() => {
        this.showfilterReadOnly = true;
        this.parseFilterReadOnly =
          this.$store.state.gestionTiempos.filterForShow;
      });

      if (this.filterReadOnly.defaults) {
        this.isDefault = true;
      } else {
        this.isDefault = false;
      }
    },
    changeFilterDefault() {
      const idFilter = this.filterReadOnly.id;
      this.$store.commit("gestionTiempos/setIdFilterShow", idFilter);
      this.$store.dispatch("gestionTiempos/editFilter").then(() => {
        this.$store.dispatch("gestionTiempos/getFilters");
        this.showfilterReadOnly = false;
      });
    },
    changeModel(value) {
      this.valueItems = value;
    },
    changeEmp() {
      let changeModel = this.valueItems;

      if (changeModel) {
        this.data = {
          Atributos: [],
          Empleados: [],
          Grupos: [],
          Horarios: [],
          Modelos: [],
          Estado: {
            Normales: [],
            Avisos: [],
            Anomalias: [],
            Extras: [],
          },
        };
      }
    },
  },
};
</script>

<style scoped>
.filter {
  max-width: 320px !important;
}

.grid__item {
  margin-bottom: 3px;
}

.container__namesfilter {
  max-height: 225px !important;
  height: auto !important;
  overflow-y: scroll !important;
  border: 1px solid #586271;
}

.container__iconClose {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-end !important;
}

.card__checks {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  max-height: 45px;
}

.card__title__readOnly {
  display: flex;
  justify-content: center;
  color: #586271;
  font-weight: lighter !important;
  text-shadow: 1px 1px #384b6d;
  padding: 0px !important;
}

.card__action__readOnly {
  display: flex;
  flex-direction: column;
}

.buttons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.bt-exit {
  color: white !important;
  background-color: #e86868 !important;
}

.btn-delete {
  background-color: #e86868 !important;
  color: white !important;
}

.actions-delete {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  height: 80px;
}

.card-filter {
  width: 700px;
}

.content-items {
  display: flex;
  flex-direction: row;
}

.btn-default-filter {
  border-radius: 20px !important;
  background-color: #39537a !important;
  color: white !important;
  box-shadow: -5px 9px 24px -4px rgba(0, 0, 0, 0.75);
  border: 2px solid #1d3861;
}

.btn-default-filter:disabled {
  background-color: #bdbdc0 !important;
  border: 2px solid #99999a;
  box-shadow: none;
}

@media (min-width: 300px) and (max-width: 450px) {
  .itemsE {
    width: 150px !important;
  }

  .options {
    width: 120px !important;
  }

  .buttons {
    display: flex;
    flex-direction: column;
  }

  .bt-acept {
    margin: 8px !important;
  }

  .title-delete {
    font-size: medium !important;
  }
}
</style>
